import { ReactNode } from 'react';

import { useConfig } from '../../../hooks/useConfig/useConfig';
import { useGetFooter } from '../../../hooks/useGetFooter/useGetFooter';
import DumbFooterSection, { DumbFooterSectionI } from './FooterSection.dumb';

/* ---------------------------------- Types --------------------------------- */

export type FooterSectionI = Omit<DumbFooterSectionI, 'data'>;

/* -------------------------------- Component ------------------------------- */

/**
 * FooterSection
 *
 * Returns a render function so we can load the footer data once but choose where to render the footer
 *
 * @returns JSX.Element
 */
const FooterSection = ({
    render,
}: {
    render: (footer: ReactNode) => ReactNode;
}) => {
    const { footerId } = useConfig();

    const { footer, loading } = useGetFooter(footerId);

    if (loading) return null;

    return render(footer ? <DumbFooterSection data={footer} /> : null);
};

/* --------------------------------- Export --------------------------------- */

export default FooterSection;
